jQuery(function (){
    console.log(window.yandex);
    if (window.YnadexClientId && window.yandex && window.yandex.app && window.logged === 'n') {

        signIn(window.YnadexClientId)
            .then(authResult => {
                let oauth_token = authResult.tokenInfo.authToken;
                let scopes = authResult.tokenInfo.authorizedScopes;

                let user_info = authResult.userInfo.payload;
                let psuid = user_info.psuid;
                let email = user_info.email;
                console.log(email);

                jQuery.ajax({
                    url: "/index.php?route=account/yandexlogin/autologin",
                    dataType: 'json',
                    type: 'post',
                    data: {
                        email: email,
                        token: oauth_token
                    },
                    success: function(result){
                        if (result.status == 'auth') {
                            window.location.reload();
                        }
                    }
                });
            })
            .catch(err =>{
                // Обработка ошибки.
            });
    }
});






// WEBPACK FOOTER //
// ./assets/javascript/yandex-autologin.js